import React from 'react';
import ReactDOM from 'react-dom';
import Breadcrumbs from './breadcrumbs';
import PropTypes from 'prop-types';

class ContentHeader extends React.Component {
  render() {
    return (
      <section className="content-header">
        <h1>
          {this.props.heading}
          {this.props.subheading ? ' ' : ''}
          {this.props.subheading ? <small>{this.props.subheading}</small> : ''}
        </h1>
        {this.props.breadcrumbs ? <Breadcrumbs /> : ''}
        {this.props.children}
      </section>
    );
  }
}
ContentHeader.propTypes = {
  heading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  subheading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  breadcrumbs: PropTypes.bool
};
ContentHeader.defaultProps = {
  heading: '',
  breadcrumbs: false
};

export default ContentHeader;
